import Root from "../layouts/Root";
import DataTable from "../components/techStack/DataTable";
import DevelopmentTable from "../components/techStack/DevelopmentTable";
import SoftwareTable from "../components/techStack/SoftwareTable";
import IconText from "../components/IconText";
import {faStar, faDatabase, faCode, faFloppyDisk} from "@fortawesome/free-solid-svg-icons";

export default function TechStack() {

    const rightContent = (
        <div>
            <p>Currently, I enjoy working with <IconText icon={faStar} text="C#" bgColor={true}/> the most.</p>
            <h1><IconText icon={faDatabase} text={"Data"}></IconText></h1>
            <DataTable/>

            <h1><IconText icon={faCode} text={"Development"}></IconText></h1>
            <DevelopmentTable/>

            <h1><IconText icon={faFloppyDisk} text={"Software"}></IconText></h1>
            <SoftwareTable/>
        </div>
    )
    return (
        <div className="techstack-page">
            <Root rightContent={rightContent}/>
        </div>
    )
}
